import { render, staticRenderFns } from "./TargetOtherUserDetailTable.vue?vue&type=template&id=3ce60227&lang=pug"
import script from "./TargetOtherUserDetailTable.vue?vue&type=script&lang=ts"
export * from "./TargetOtherUserDetailTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports